import React from 'react';
import { useMsal } from '@azure/msal-react';
import { FaLock, FaSignOutAlt, FaHeadset, FaInfoCircle } from 'react-icons/fa';
import SplashCursor from '../components/SplashCursor';
import './UnauthorizedPage.css';

function UnauthorizedPage() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const userEmail = account?.username || 'Unknown Account';

  const handleLogout = () => {
    // Standard logout, clears the token cache so they can choose a different Microsoft account
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  };

  return (
    <div className="unauth">
      {/* Same tuning as the SignInScreen: single-color, non-rainbow so it reads
          as ambient brand texture rather than a novelty effect. */}
      <SplashCursor COLOR="#2f6fed" RAINBOW_MODE={false} SPLAT_FORCE={4500} DENSITY_DISSIPATION={3.5} />

      <div className="unauth__card">
        <div className="unauth__top">
          <div className="unauth__icon-circle">
            <FaLock size={24} />
          </div>
        </div>

        <div className="unauth__bottom">
          <p className="unauth__eyebrow">Access Restricted</p>
          <h1 className="unauth__title">Subscription Required</h1>
          <p className="unauth__body">
            It looks like you don't have an active license or assigned corporate role for OrientalPay.
          </p>

          <div className="unauth__account-box">
            <span className="unauth__account-label">Attempted Login Account</span>
            <span className="unauth__account-value">{userEmail}</span>
          </div>

          <p className="unauth__hint">
            If you logged in with the correct account, please <strong>contact your OrientalPay administrator</strong> to
            purchase a subscription or provision your access. Otherwise, you may need to sign out and use your work email.
          </p>

          <div className="unauth__actions">
            <button className="unauth-btn unauth-btn-primary" onClick={handleLogout}>
              <FaSignOutAlt /> Sign Out &amp; Switch Account
            </button>

            <div className="unauth__secondary-row">
              <a
                href="https://orientalpay.ca/pricing"
                target="_blank"
                rel="noopener noreferrer"
                className="unauth-btn unauth-btn-secondary"
              >
                <FaInfoCircle /> View Pricing
              </a>
              <a
                href="https://orientalpay.ca/contact"
                target="_blank"
                rel="noopener noreferrer"
                className="unauth-btn unauth-btn-secondary"
              >
                <FaHeadset /> Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnauthorizedPage;